import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import {useState} from 'react'
import {setReferenceCreator,createChatResourceReference} from '../messageCenterSlice'
import {useSelector,useDispatch} from 'react-redux'
import Select from 'react-select'
import Button from 'react-bootstrap/Button'
import {useClients} from '../../users/hooks'
import useCurrentUser from '../../../hooks/useCurrentUser'

const CreatorModal = ()=>{
	const user = useCurrentUser()
	const dispatch = useDispatch()
	const [status,setStatus] = useState('idle')
	const [selectedClient,setSelectedClient] = useState(null)
	const {clients} = useClients({
		include_compliance:Number(user.account_type !== 'chain')
	})
	const {show,resource} = useSelector(state=>state.messageCenter.resourceReferenceCreator)
	
	const onHide = ()=>{
		dispatch(
			setReferenceCreator({show:false,resource})
		)
	}

	const handleDiscuss = ()=>{
		setStatus('pending')
		dispatch(createChatResourceReference({
			resource_type:resource.type,
			resource_id:resource.id,
			user_id_number:selectedClient.value
		}))
		.then(()=>{
			onHide()
			setStatus('idle')
		})
	}

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header>
				Discuss {resource.type} in the chat <strong>{resource.name}</strong>
			</Modal.Header>
			<Modal.Body>
				<strong>Select a Client</strong>
				<Select 
					onChange={setSelectedClient}
					options={
						clients.map(
							c => ({value:c.user_id_number,label:c.user_name})
						)
					}
				/>
				<div className="text-right">
					<Button
						onClick={handleDiscuss}
						disabled={!Boolean(selectedClient)||status==='pending'}
						variant="outline-success"
						className="mt-2"
						size="sm"
					>
						Discuss now {status==='pending'&&<Spinner animation="border" size="sm"/>}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default CreatorModal